module.exports = __webpack_public_path__ + "img/draw-fail.fddc4c69.png";